import { ISelectValue, IUser } from '@/@types'
import { DataTableFacetedFilter } from '@/components/data-table/faceted-filter'
import { Table } from '@tanstack/react-table'

interface Props {
  table?: Table<IUser>
}

export function TableToolbar({ table }: Props) {
  const paymentStatuses: ISelectValue[] = [
    { label: 'Ativo', value: 'ACTIVE' },
    { label: 'Expirado', value: 'EXPIRED' },
    { label: 'Bloqueado', value: 'BLOCKED' },
    { label: 'Gratuito', value: 'FREE' },
    { label: 'Promoção', value: 'PROMOTION' },
  ]

  if (!table) return null

  return (
    <>
      {paymentStatuses && (
        <DataTableFacetedFilter
          title="Filtrar"
          table={table}
          columnId="signature"
          options={paymentStatuses}
        />
      )}
    </>
  )
}
